// Basic
import { useEffect, useState } from 'react';
// Store & actions
import useRootOrganizationStore from '@/app/store/rootOrganization';
import actionsPushPayments from '../../api/actionsPushPayments';
// Components
import DataTable from '@/common-utils/components/renders/dataTable/DataTable';
// Common
import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import mergeQuery from '@/common-utils/components/renders/dataTable/utils/mergeQuery';
import Permissions from '@/app/permissions/Permissions';
import { columnsNotifRules, columnsNotifRulesId } from './columnsDef/columnsNotifRules';
import { PUSH_PAYMENTS } from '../../api/apiUrls';
import NotifRulesImportProps from '../import/NotifRulesImportProps';
import usePushPaymentStore from '@/app/store/modules/pushPayment';
import PropTypes from 'prop-types';

/**
 * @param root0
 * @param root0.filtersEventName
 *@returns {JSX} NotifRulesTable
 */
function NotifRulesTable({ filtersEventName }) {
    // Store
    const rootOrganization = useRootOrganizationStore(s => s.rootOrganization);
    const { queryNotifRules: queryStored, storeQueryNotifRules } = usePushPaymentStore();

    // Constants
    const initialQuery = getInitialQuery();

    // State
    const [query, setQuery] = useState(mergeQuery(initialQuery, queryStored));
    const [launchRefetch, setLaunchRefetch] = useState(true);

    // Api Calls
    const { data, isFetching, error, refetch } = actionsPushPayments.getNotifRules({ query }, false);

    useEffect(() => {
        if (rootOrganization && launchRefetch) {
            refetch();
            setLaunchRefetch(false);
        }
    }, [query, launchRefetch, rootOrganization]);

    const allColumns = columnsNotifRules({ query, setQuery, queryStored, storeQueryNotifRules, setLaunchRefetch, filtersEventName });

    return (
        <DataTable
            filtersEventName={filtersEventName}
            columns={allColumns}
            data={data}
            dataFetchingIsLoading={isFetching}
            error={error}
            refetch={refetch}
            columnsId={columnsNotifRulesId}
            initialQuery={initialQuery}
            query={query}
            setQuery={setQuery}
            queryStored={queryStored}
            storeQuery={storeQueryNotifRules}
            setLaunchRefetch={setLaunchRefetch}

            exportProps={{
                permissions: [Permissions.PUSH_PAYMENT_EXPORT.name],
                api: PUSH_PAYMENTS.NOTIF_RULES.EXPORT
            }}
            importProps={{
                ...NotifRulesImportProps,
                setLaunchRefetch,
                permissions: [Permissions.PUSH_PAYMENT_IMPORT.name]
            }}
        />
    );
}

NotifRulesTable.propTypes = {
    filtersEventName: PropTypes.string
};

export default NotifRulesTable;